// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__AWIXx","modal":"Modal_modal__lZUys","slide-down":"Modal_slide-down__UuXNJ","close":"Modal_close__uECvh"};